import React from 'react'

import type { Collection, CollectionUUID } from '@library/menu-service'

import { useCollection } from 'hooks/menu-collections'

import { SearchCategoriesGrid } from '../SearchCategoriesGrid/SearchCategoriesGrid'
import type { SearchCategoryProps } from '../SearchCategory/SearchCategory'
import { getCategoryImageUrl } from '../utils'

export const PopularCategories = () => {
  const popularCollections = [
    useCollection('56b88b66-7e0b-11ec-a129-02e1cea636b3' as CollectionUUID), // New & Limited
    useCollection('b6606d9e-2dbb-11ed-a194-022218cc141f' as CollectionUUID), // Quick & Easy
    useCollection('1b24de1c-3473-11ef-8044-06a0257ab9ff' as CollectionUUID), // Healthy Choices
    useCollection('e55383da-336d-11e9-b24d-06399ef4685e' as CollectionUUID), // Everyday Favourites
    useCollection('5c117c20-8b05-11e6-8538-065f01f5b2df' as CollectionUUID), // Vegetarian
    useCollection('6c5806f2-61b5-11ed-a541-027900d93479' as CollectionUUID), // Save & Savour
  ].filter((collection): collection is Collection => Boolean(collection))

  const popularCategories: SearchCategoryProps[] = popularCollections
    .filter((collection) => collection.recipes.length !== 0)
    .map((collection) => ({
      id: collection.id,
      slug: collection.slug,
      imageUrl: getCategoryImageUrl(collection.id),
      name: collection.shortTitle,
      recipeCount: collection.recipes.length,
    }))

  return <SearchCategoriesGrid categories={popularCategories} title="Popular Categories" />
}
